import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function ShowcaseImageLightbox({
  src,
  alt,
  className,
  loading = "lazy",
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = "hidden";

    const handleKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <>
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={className}
        onClick={() => setOpen(true)}
        style={{ cursor: "zoom-in" }}
      />

      {open && (
        <div
          className="ShowcaseLightbox_overlay"
          onClick={() => setOpen(false)}
        >
          <button
            type="button"
            className="ShowcaseLightbox_close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <X size={22} />
          </button>

          <img
            src={src}
            alt={alt}
            className="ShowcaseLightbox_image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
